import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { ProgressBarComponent } from '../../../../../shared/ui-components/progress-bar/progress-bar.component';
import { CardComponent } from '@/shared/ui-components/card/card.component';

import { SvgIconComponent } from 'angular-svg-icon';
import { BestSellingWidgetItem } from '@/pages/dashboards/admin-dashboard/data-access/admin-dashboard.model';

@Component({
    standalone: true,
    selector: 'app-best-selling-widget',
    imports: [CommonModule, ButtonModule, MenuModule, ProgressBarComponent, CardComponent, SvgIconComponent],
    templateUrl: './bestsellingwidget.html',
    styles: [`
        :host {
            display: block;
            height: 100%;
        }
        
        :host ::ng-deep app-card {
            height: 100%;
            display: block;
        }
        
        :host ::ng-deep app-card .p-card {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        
        :host ::ng-deep app-card .p-card-body {
            flex: 1;
            display: flex;
            flex-direction: column;
        }
    `]
})
export class BestSellingWidget {
  @Input() title: string = 'Total Investment Volume';
  @Input() items: BestSellingWidgetItem[] = [];

  menuItems = [
    { label: 'Add New', icon: 'pi pi-plus' },
    { label: 'Remove', icon: 'pi pi-trash' }
  ];

  /** Backward compat for template naming. */
  get investments(): { name: string; value: number; icon: string }[] {
    return (this.items ?? []).map((i) => ({
      name: i.label,
      value: i.percentage,
      icon: i.icon,
    }));
  }
}
